module.exports = __webpack_public_path__ + "img/level_logo1.1847e374.png";